module.exports = __webpack_public_path__ + "img/join4-3-h.c7640544.svg";